// counter for time left to be shown to player 
// once verification of mobile phone is sent
// (player can't send new request for a verification
// for next 3 minutes)
// default value is set to 3 minutes
// used on editprofile.jsp form

var time_countdown = function () {
	// var time_left = 10; //number of seconds for countdown
	 var time_left; //number of seconds for countdown
	 var output_element_id = 'resend_ver';
	 //var output_element_id = 'time_counter_1';
	var keep_counting = 1;
	var name;
	var ttt;
	
	function countdown() {
		
		if(time_left < 2) {
			keep_counting = 0;
		}
 
		time_left = time_left - 1;
	}
 
	function add_leading_zero(n) {
		if(n.toString().length < 2) {
			return '0' + n;
		} else {
			return n;
		}
	}
 
	function format_output() {
		var minutes, seconds;
		seconds = time_left % 60;
		minutes = Math.floor(time_left / 60) % 60;
 
		seconds = add_leading_zero( seconds );
		minutes = add_leading_zero( minutes );
 
		return minutes + ':' + seconds;
	}
 
	function show_time_left() {
		document.getElementById(output_element_id).innerHTML = format_output();//time_left;
	}
 
	function no_time_left() {
		
		document.getElementById("resend_ver_1").style.display='block';
		document.getElementById("time_counter_1").style.display='none';
		document.getElementById("resend_ver_0").style.display='block';
		document.getElementById("time_counter_0").style.display='none';
		keep_counting = 1;
	}
 
	return {
		count: function () {
			countdown();
			show_time_left();
		},
		timer: function () {
			time_countdown.count();
 
			// set value of cookie
			setCookie(name, time_left, 365);
			
			if(keep_counting) {
				ttt = setTimeout("time_countdown.timer();", 1000);
				
			} else {
				no_time_left();
				setCookie(name, 0, 365);
				// clearTimeout(t);
			}
		},

		setTimeLeft: function (t) {
			time_left = t;
			if(keep_counting == 0) {
				time_countdown.timer();
			}
		},
		
		init: function (t, element_id, cookieName) {
			
				clearTimeout(ttt);
			 
				time_left = t;
				output_element_id = element_id;
				time_countdown.timer();
				name = cookieName;
		}

	};
}(); 

define("legacy/timecountdown", function(){});

